import './main.less';
import './discounts-shared.less';
import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import _get from 'lodash/get';

import InputField from '../../../shared/form-elements/input';
import TextArea from '../../../shared/form-elements/textarea';
import RadioField from '../../../shared/form-elements/radio';
import UploadField from '../../../shared/form-elements/upload';

let Main = props => {
	const submit = data => props.formSubmit(data, props);
	const { is_link_promo_code } = props;

	return (
		<div className="discounts-form-wrap">
			<form className="ui-form clearfix ui-form__element title" onSubmit={e => props.handleSubmit(submit)(e)}>
				<div className="top_block">
					<div className="partner_fields">
						<div className="discount__descriptions">
							<div className="discount__partner-title-en">
								<Field
									name="partner_name"
									placeholder={props.intl('Partner name')}
									component={InputField}
								/>
							</div>
							<div className="discount__partner-title-ru">
								<Field
									name="discounts_end_at"
									placeholder={'Valid to (DD-MM-YYYY)'}
									normalize={normalizeEndDate}
									input_placeholder = 'Lifetime duration'
									component={InputField}
								/>
							</div>
						</div>
						<div className="discount__descriptions">
							<div className="discount__descriptions-ru">
								<Field
									name="partner_description_ru"
									placeholder={props.intl('Description ru')}
									component={TextArea}
								/>
							</div>
							<div className="discount__descriptions-en">
								<Field
									name="partner_description_en"
									placeholder={props.intl('Description en')}
									component={TextArea}
								/>
							</div>
						</div>
					</div>
					<div className="partner-logo__container">
						<Field
							name="partner_logo"
							component={UploadField}
							placeholder={ 'Upload' }
							preparationFile={props.preparationFile}
						/>
						<div>
							<div className="promocode-link__switch">
								<Field
									name="is_link_promo_code"
									labelText="Promo-link"
									defaultValue={true}
									component={RadioField}
								/>
								<Field
									name="is_link_promo_code"
									labelText="Promo-code"
									defaultValue={false}
									component={RadioField}
								/>
							</div>
						</div>
					</div>
				</div>
				<div>
					<div className="discount__descriptions-title">
						<div className="promo_code">
							<Field
								name="promo_code"
								placeholder={props.intl(
									is_link_promo_code ? 'Promo-link' : 'Promo-code'
								)}
								component={InputField}
							/>
						</div>
						<div className="discount_value">
							<Field
								name="discount_value"
								placeholder={props.intl('Discount value')}
								component={InputField}
							/>
						</div>
						<div className="redirect_link">
							<Field
								name="redirect_link"
								placeholder={props.intl('Redirect link')}
								component={InputField}
							/>
						</div>
					</div>
					<div className="discount__descriptions">
						<div className="discount__descriptions-ru">
							<Field
								name="terms_ru"
								placeholder={props.intl('Terms ru')}
								component={TextArea}
							/>
						</div>
						<div className="discount__descriptions-en">
							<Field
								name="terms_en"
								placeholder={props.intl('Terms en')}
								component={TextArea}
							/>
						</div>
					</div>
				</div>
				<div className="discounts-group group-right">
					<div className="ui-form__element buttons-wrap">
						{props.can('edit')&&
						<button type="submit" className="ui-btn ui-btn-primary">
							{'Save'}
						</button>}
					</div>
				</div>
			</form>
		</div>
	);
};

const normalizeEndDate = (newValue, oldValue) => {
	let replacedValue = newValue.replace(/\\D/g, '').replace(/-/g, '');
	if (!replacedValue) return newValue;
	if (oldValue && oldValue.slice(newValue.length, newValue.length + 1) === '-') {
		replacedValue = replacedValue.slice(0, replacedValue.length - 1);
	}

	const day = replacedValue.slice(0, 2);
	const month = replacedValue.slice(2, 4);
	const year = replacedValue.slice(4, 8);

	switch (true) {
		case replacedValue.length === 1:
			return  replacedValue;
		case replacedValue.length < 3:
			return day <= 31 && day > 0 ? `${day}-` : `30-`;
		case replacedValue.length === 3:
			return  `${day}-${month}`;
		case replacedValue.length < 5:
			return month <= 12 && month > 0 ? `${day}-${month}-` : `${day}-12-`;
		default :
			return `${day}-${month}-${year}`;
	}
};

Main.propTypes = {
	className: PropTypes.string,
	data: PropTypes.array,
	is_link_promo_code: PropTypes.bool,
	formLangs: PropTypes.array,
	formData: PropTypes.object,
	params: PropTypes.object,
	anyTouched: PropTypes.bool,
	handleSubmit: PropTypes.func,
	submitDeleteDiscountTerm: PropTypes.func,
	addDiscountTerm: PropTypes.func,
	addNewTerm: PropTypes.func,
	formSubmit: PropTypes.func,
	preparationFile: PropTypes.func,
	formSubmitTranslation: PropTypes.func,
	formChangeLanguage: PropTypes.func,
	offersLookups: PropTypes.func,
	intl: PropTypes.func,
	can: PropTypes.func
};

const validate = values => {
	const errors = {};
	const notEmptyFields = ['partner_name', 'partner_description_en', 'partner_description_ru',
		'terms_ru', 'terms_en', 'redirect_link', 'discount_value', 'promo_code'
	];
	notEmptyFields.forEach(field => !values[field] && (errors[field] = 'Should not be empty'));
	if (values.discounts_end_at && moment(values.discounts_end_at, 'DD-MM-YYYY').diff(moment()) < 0) {
		errors.discounts_end_at = 'Should be after current date';
	}
	return errors;
};

Main = reduxForm({
	form: 'discountsEdit',
	validate
})(Main);

Main = connect(
	state => ({
		initialValues: state.discountsEdit.data,
		is_link_promo_code: _get(state, 'form.discountsEdit.values.is_link_promo_code')
	})
)(Main);

export default  Main;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/discounts/components/form/main.js